import {useNavigate} from "react-router";
import {SETTINGS_PATH, useRoutesByTag} from "../../../service/routeProvider.tsx";
import ListItemLink from "./ListItemLink.tsx";
import {useAppSelector} from "../../../hooks/reduxHooks.ts";
import useDirtyLeaveCheck from "../../../hooks/useDirtyLeaveCheck.ts";
import BrandMarkSVG from "../../icons/BrandMarkSVG.tsx";
import {useTranslation} from "react-i18next";
import SidebarUserCard from "./SidebarUserCard.tsx";
import useMediaQuery from "@mui/material/useMediaQuery";
import {useMailServerHealth} from "../../../hooks/useMailServerHealth.ts";
import {needsAttention} from "../../../model/mailServer/MailServer.ts";

const Navigation = () => {
    const {t} = useTranslation();
    const myAccount = useAppSelector(state => state.auth.myAccount);
    const links = useRoutesByTag("Menu");
    const navigate = useNavigate();
    // The logo is a plain navigation target too, so it must honour the same
    // unsaved-changes guard as the menu links (see ListItemLink).
    const {denyDirtyLeave, dialog: confirmDialog} = useDirtyLeaveCheck();
    // Tailwind's `sm` breakpoint is 640px — collapse the sidebar below that.
    const isMobile = useMediaQuery("(max-width: 639px)");
    const mailServerHealth = useMailServerHealth();

    const handleLogoNavigate = async () => {
        if (await denyDirtyLeave()) return;
        void navigate("/");
    };

    return (
        <nav
            className="an-shape [--an-shape-cut:10px] sm:[--an-shape-cut:52px] box-border w-20 sm:w-[280px] shrink-0 self-stretch bg-an-panel px-2 sm:px-6 py-6 flex flex-col gap-4 sm:gap-6 overflow-y-auto overflow-x-hidden min-w-0"
        >
            <button
                type="button"
                onClick={() => { void handleLogoNavigate(); }}
                className="bg-transparent border-0 p-0 cursor-pointer no-underline flex justify-center sm:block w-full mb-2 sm:mb-4"
                aria-label={t("defaults.appName")}
            >
                <BrandMarkSVG className="block max-w-full h-auto w-12 sm:w-full"/>
            </button>

            <ul className="list-none p-0 m-0 flex flex-col gap-1 flex-1">
                {links.map(link => (
                    <ListItemLink
                        icon={link.icon}
                        key={link.path}
                        to={link.path}
                        label={link.label ?? ""}
                        alert={link.path === SETTINGS_PATH && needsAttention(mailServerHealth)
                            ? "settings.mailServer.attentionRequired"
                            : undefined}
                    />
                ))}
            </ul>

            {myAccount && (
                <SidebarUserCard myAccount={myAccount} collapsed={isMobile}/>
            )}

            {confirmDialog}
        </nav>
    );
};

export default Navigation;
